import { Heading } from 'almanac-ui/Heading/Heading'
import { sendToApi } from 'api/client'
import { Button } from 'components/Button'
import { useMutation } from 'react-query'
import { Spinner } from 'common/Spinner/Spinner'

import Styles from './Empty.module.scss'

const EMPTY_STATE_IMAGE =
  'https://res.cloudinary.com/almanac/image/upload/v1697726677/blaze_assets/empty-state-image_xh0twt.png'

const sendContentTypeRequest = async (contentType: string) => {
  const res = await sendToApi(`/content_type_request`, {
    method: 'POST',
    body: {
      content_type: contentType,
    },
  })

  if (res.type === 'error') {
    throw new Error(res.statusText || 'API Error')
  }

  return res
}

export const Empty = ({ query }: { query: string }) => {
  const mutation = useMutation((contentType: string) => sendContentTypeRequest(contentType))

  return (
    <div className={Styles.emptyContainer}>
      <div className={Styles.empty}>
        <img src={EMPTY_STATE_IMAGE} alt="No results" />
        <div className={Styles.query}>"{query}"</div>
      </div>
      <div className={Styles.emptyText}>
        <Heading level={4}>Request a new content type</Heading>
        <div className={Styles.actions}>
          {mutation.isSuccess && (
            <Heading level={4} color="#04AF00">
              Request Sent!
            </Heading>
          )}
          {mutation.isLoading && <Spinner />}
          {mutation.isError && (
            <Heading level={4} color="var(--negative-50)">
              Request Failed
            </Heading>
          )}
          {mutation.isIdle && (
            <Button variant="secondary" size="lg" onPress={() => mutation.mutateAsync(query)}>
              Send Request
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
